'use strict';

var deltaCalc = require('./delta-calc.cjs');

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
    return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
    return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
    return (Math.round(a.min) === Math.round(b.min) &&
        Math.round(a.max) === Math.round(b.max));
}
function boxEqualsRounded(a, b) {
    return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
    return deltaCalc.calcLength(box.x) / deltaCalc.calcLength(box.y);
}
function axisDeltaEquals(a, b) {
    return (a.translate === b.translate &&
        a.scale === b.scale &&
        a.originPoint === b.originPoint);
}

exports.aspectRatio = aspectRatio;
exports.axisDeltaEquals = axisDeltaEquals;
exports.axisEquals = axisEquals;
exports.axisEqualsRounded = axisEqualsRounded;
exports.boxEquals = boxEquals;
exports.boxEqualsRounded = boxEqualsRounded;
exports.isDeltaZero = isDeltaZero;
//# sourceMappingURL=utils.cjs.map
